import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DentalService } from 'src/app/_service/dental.service';
declare var $: any;
import * as XLSX from 'xlsx';
import { formatDate } from '@angular/common';


@Component({
  selector: 'app-payment-report',
  templateUrl: './payment-report.component.html',
  styleUrls: ['./payment-report.component.css']
})
export class PaymentReportComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;
  @ViewChild('paymentReceivedStart', { static: false }) paymentReceivedStart: ElementRef;
  @ViewChild('paymentReceivedEnd', { static: false }) paymentReceivedEnd: ElementRef;

  perpage: number = 25; paymentData: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; myrole: string;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circles = []; circle = '';
  search: string; currentUserId: any; circles_copy = []; payment_mode = ''; start_date: string = ''; end_date: string = '';
  start_date_payment_received: string = ''; end_date_payment_received: string = ''; bds = []; bds_copy = []; bd: string; sc3Url: string = '';
  booleanValue: any = false;
  constructor(private userapi: UserService, private sharedapi: SharedService, public leadapi: LeadsService, private dialog: MatDialog, private dentalapi: DentalService,) { }

  ngOnInit(): void {
    this.sc3Url = localStorage.getItem('s3url');
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.currentUserId = localStorage.getItem('loginuserId');
    this.getcircle();
    this.getbds();
  }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if (type == 'bds') {
      $("#bd_search").val('');
      $("#bd_search").focus();
      this.bds = this.bds_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if (type == 'bds') {
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    }
  }

  ngAfterViewInit() {
    this.loadPaymentReportData(0, this.perpage);
  }

  async loadPaymentReportData(pageIndex, perpage) {
    this.paymentData = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&circle=' + this.circle + '&payment_mode=' + this.payment_mode + '&bd=' + this.bd + '&date_range=' + this.start_date + '-' + this.end_date + '&payment_received_date=' + this.start_date_payment_received + '-' + this.end_date_payment_received;
    this.loading = true; this.loaded = false;
    this.dentalapi.getPaymentReportData(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.paymentData = data.data;
      } else {
        this.paymentData = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  getCircleName(circleData) {
    var splittedStringArray = circleData.split(",");
    let circleNames = '';
    splittedStringArray.forEach(element => {
      circleNames += '<span class="circleNamestyle">' + element + '</span>';
    });
    return circleNames;
  }
  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadPaymentReportData(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadPaymentReportData(event.pageIndex, event.pageSize);
  }


  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  dateRangeChange(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }

  clearDate() {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

  dateRangeChangefollowUp(date1, date2) {
    if (date2.value) {
      this.start_date_payment_received = date1.value;
      this.end_date_payment_received = date2.value;
    }
  }

  clearPaymentReceivedDate() {
    this.paymentReceivedStart.nativeElement.value = "";
    this.paymentReceivedEnd.nativeElement.value = "";
    this.start_date_payment_received = '';
    this.end_date_payment_received = '';
  }

  async getbds(status = 1) {
    this.leadapi.getAccountsUsers(status).subscribe((data: any) => {
      if (data.status) {
        this.bds = data.data;
        this.bds_copy = this.bds;
      } else {
        this.bds = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  resetFilters() {
    this.clearDate();
    this.clearPaymentReceivedDate();

    this.search = ''; this.bd = ''; this.circle = ''; this.payment_mode = '';
    this.loadPaymentReportData(0, 25);
  }

  //------------------Export Product List---------------------//
  exportProductList() {
    if (this.paymentData.length > 0) {
      let data = [];
      let titles = ['PATIENT ID', 'PATIENT NAME', 'PATIENT CONTACT NO', 'CIRCLE', 'SCAN DATE', 'PAYMENT DATE', 'TOTAL PAYMENT', 'DOWN PAYMENT RECEIVED', 'BALANCE PAYMENT', 'PAYMENT MODE', 'CONVERT TYPE', 'CONVERTED BY', 'ANY OTHER DENTAL PROCEDURE', 'TRANSACTION ID', 'VERIFIED BY ACCOUNTS', '	VERIFICATION DATE', 'ACCOUNTS REMARKS', 'PAYMENT RECEIVE DATE', 'PAYMENT RECEIVED AMOUNT (BY ACCOUNTS)', 'VERIFIED BY'];

      data.push(titles);
      for (let key in this.paymentData) {

        var scan_done_date = '';
        if (this.paymentData[key].scan_done_date) {
          scan_done_date = formatDate(this.paymentData[key].scan_done_date * 1000, 'dd MMM, yyyy', 'en-US');
        }
        var payment_datetime = '';
        if (this.paymentData[key].payment_datetime) {
          payment_datetime = formatDate(this.paymentData[key].payment_datetime * 1000, 'dd MMM, yyyy', 'en-US');
        }

        var verification_date_by_accounts = '';
        if (this.paymentData[key].verification_date_by_accounts) {
          verification_date_by_accounts = formatDate(this.paymentData[key].verification_date_by_accounts * 1000, 'dd MMM, yyyy', 'en-US');
        }

        var payment_rec_date_by_acc = '';
        if (this.paymentData[key].payment_rec_date_by_acc) {
          payment_rec_date_by_acc = formatDate(this.paymentData[key].payment_rec_date_by_acc * 1000, 'dd MMM, yyyy', 'en-US');
        }

        let extData = [this.paymentData[key].glamyo_patient_id, this.paymentData[key].lead_name, this.paymentData[key].mobile, this.paymentData[key].circle_name, scan_done_date, payment_datetime, this.paymentData[key].billed_amt, this.paymentData[key].received_amt, this.paymentData[key].balanceAmount, this.paymentData[key].payment_mode, this.paymentData[key].convert_type, this.paymentData[key].converted_transaction_by, this.paymentData[key].any_other_dental, this.paymentData[key].transaction_id, this.paymentData[key].verified_by_accounts, verification_date_by_accounts, this.paymentData[key].accounts_remarks, payment_rec_date_by_acc, this.paymentData[key].rec_amount_by_account, this.paymentData[key].accounts_user_id_name];

        data.push(extData)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      XLSX.writeFile(wb, 'dental_payment_report_' + utc + '.xlsx');
    } else {
      this.sharedapi.presentToast('No payment Data found!');
    }
  }

}
